import React, {useState} from 'react';
import {Modal, Button, Popup} from 'semantic-ui-react';
import AdvisorManagementForm from '../advisorManagement/form/index';
import ClientManagementForm from '../clientManagement/form/index';
import ExemptionManagement from '../exemptionManagement/form/index';
import './styles.scss';

const forms = (contentType, closeModal, create, code, dealerRuc) => {
  const managementForms = {
    'client': <ClientManagementForm closeModal={closeModal} create={create} code={code} dealerRuc={dealerRuc} />,
    'advisor': <AdvisorManagementForm closeModal={closeModal} create={create} code={code} />,
    'exemption': <ExemptionManagement closeModal={closeModal} create={create} code={code} />,
  };
  return managementForms[contentType];
};

const FormModal = ({
  detail,
  code,
  headerTitle,
  create,
  contentType,
  dealerRuc,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const renderTrigger = () => {
    if (!create) {
      return (
        <Popup
          trigger={
            <span className="link">
              <i className="material-icons" onClick={openModal}>
                edition
              </i>
            </span>
          }
          content={`Edicion ${detail}`}
          position="top center"
          inverted
        />
      );
    }
  
    return (
      <Button
        primary
        className="toyota-primary"
        onClick={openModal}
      >
        Añadir nuevo
      </Button>
    );
  };

  return (
    <Modal
      onOpen={openModal}
      open={modalIsOpen}
      className="form-modal scroll-modal-custom"
      trigger={renderTrigger()}
    >
      <Modal.Header>{headerTitle}</Modal.Header>
      <Modal.Content className="form-detail-content">
        {forms(contentType, closeModal, create, code, dealerRuc)}
      </Modal.Content>
    </Modal>
  );
};

export default FormModal;
